import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { RouterProvider } from "@tanstack/react-router"
import { router } from "./router"
import { initSentry } from "./config/sentry"
import { initAnalytics } from "@/features/analytics"
import { bootstrapConfig } from "@/features/config"
import { ErrorBoundary } from "./components/error-boundary"
import { LoadingSpinner } from "@/shared/components/loading-spinner"
import "./index.css"

console.log(
  `%c ${APP_RELEASE} %c ${import.meta.env.MODE} `,
  "background:#6C5CE7;color:#fff;border-radius:3px 0 0 3px;padding:2px 6px",
  "background:#00B894;color:#fff;border-radius:0 3px 3px 0;padding:2px 6px",
)

initSentry()

const root = createRoot(document.getElementById("root")!)

const splash = (
  <div className="flex min-h-[100dvh] items-center justify-center bg-background">
    <LoadingSpinner />
  </div>
)

function renderApp() {
  root.render(
    <StrictMode>
      <ErrorBoundary>
        <RouterProvider router={router} />
      </ErrorBoundary>
    </StrictMode>,
  )
}

// Resolve the funnel config (cfg_* in the URL) before the router mounts, so it
// never sees the config path and params are ready for the first render. Init
// analytics only after config resolves, so the `fb`/`gg` params (priority 0)
// can override the env pixel/gtag ids before the providers boot.
root.render(splash)
bootstrapConfig().finally(() => {
  initAnalytics()
  renderApp()
})
